import Long from 'long';
import { InvalidArgumentError } from '#common/types';
export const MAX_U64_BIGINT_VALUE = 0xffffffffffffffffn;
export const MAX_I64_BIGINT_VALUE = 0x7fffffffffffffffn;
export const MIN_I64_BIGINT_VALUE = -0x8000000000000000n;
function canSafelyConvertBigIntToLong(toLong, unsigned = true) {
    if (unsigned) {
        return toLong >= 0n && toLong <= MAX_U64_BIGINT_VALUE;
    }
    return toLong >= MIN_I64_BIGINT_VALUE && toLong <= MAX_I64_BIGINT_VALUE;
}
export function bigIntToLong(toLong, unsigned = true) {
    if (!canSafelyConvertBigIntToLong(toLong, unsigned)) {
        throw new InvalidArgumentError(`Cannot convert BigInt to Long: ${toLong}`);
    }
    const lowBits = Number(toLong & 0xffffffffn);
    const highBits = Number(toLong >> 32n);
    return new Long(lowBits, highBits, unsigned);
}
export function longToBigInt(toBigInt) {
    const highBits = toBigInt.unsigned
        ? BigInt(toBigInt.getHighBitsUnsigned())
        : BigInt(toBigInt.getHighBits());
    return (highBits << 32n) | BigInt(toBigInt.getLowBitsUnsigned());
}
export function stringifyReplacerForBigInt(_key, value) {
    if (typeof value === 'bigint') {
        return value.toString();
    }
    return value;
}
